import { render, staticRenderFns } from "./website-menu.vue?vue&type=template&id=0472b2e9&scoped=true&"
import script from "./website-menu.vue?vue&type=script&lang=js&"
export * from "./website-menu.vue?vue&type=script&lang=js&"
import style0 from "./website-menu.vue?vue&type=style&index=0&id=0472b2e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472b2e9",
  null
  
)

export default component.exports